import React from 'react';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Fade from '@mui/material/Fade';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaTable from 'Components/UI/Meta/MetaTable';
import BulkCommunicationSummaryStat from './SummaryStat';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: theme.spacing(2),
    alignContent: 'flex-start',
  },
  table: {
    minWidth: 650,
  },
  stats: {
    marginTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'row',
  },
  tableContainer: {
    maxHeight: '80vh',
    overflowY: 'scroll',
  },
});

const BulkCommunicationSummaryDialogContent = ({
  className,
  classes,
  bulkCommunicationSummaryResource,
}) => {
  const summaryCollection = fr.collection(bulkCommunicationSummaryResource?.attr('items'));
  return (
    <Fade in>
      <Box
        className={classNames(classes.root, className)}
      >
        {summaryCollection && (
          <div
            className={classes.tableContainer}
            test={'bulk-communication-summary-table'}
          >
            <MetaTable
              className={classes.table}
              collection={summaryCollection}
              tableMetaOverrideSetName="BulkCommunicationSummaryTable"
              features={{}}
              HeadRowProps={{
                className: classes.head,
              }}
              columns={[
                { name: 'householdId' },
                { name: 'threadSubject' },
                { name: 'messageContent', style: { width: '55%' } },
                { name: 'timeSent' },
                { name: 'status' },
              ]}
              disablePagination
            />
          </div>)
        }
        <div
          className={classes.stats}
          test={'bulk-communication-summary-stats'}
        >
          <BulkCommunicationSummaryStat
            label={'Total Households'}
            value={bulkCommunicationSummaryResource?.attr('totalHouseholds')}
          />
          <BulkCommunicationSummaryStat
            label={'Total Pending'}
            value={bulkCommunicationSummaryResource?.attr('totalPending')}
          />
          <BulkCommunicationSummaryStat
            label={'Total Sent'}
            value={bulkCommunicationSummaryResource?.attr('totalSent')}
          />
        </div>
      </Box>
    </Fade>
  );
};

BulkCommunicationSummaryDialogContent.defaultProps = {
  className: '',
  bulkCommunicationSummaryResource: {},
};

BulkCommunicationSummaryDialogContent.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  bulkCommunicationSummaryResource: PropTypes.object,
};

export default withStyles(styles)(BulkCommunicationSummaryDialogContent);
